import { Done } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const Disclaimer = () => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 5,
			}}
		>
			<Typography variant='h5' sx={{ fontWeight: 700, display: 'flex', justifyContent: 'center' }}>
				Renewals Disclaimer
			</Typography>
			<Typography variant='subtitle1' sx={{ textAlign: 'center' }}>
				To renew your policy, you must confirm that there have been no material changes since your last policy. A
				material fact is a piece of information that would directly influence an insurer in assessing and setting your
				premium – and must be disclosed. Examples of material facts can be:
			</Typography>
			<Box
				component='ul'
				sx={{
					m: 0,
					p: 0,
					listStyle: 'none',
					display: 'flex',
					flexDirection: 'column',
					gap: 3,
				}}
			>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />{' '}
					<Typography variant='subtitle2'>There has been an accident/incident, regardless of blame.</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>
						You have received a conviction for a driving offence or a fixed notice resulting in a license endorsement.
					</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>Change of car.</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>
						Development of relevant health problems: This includes anything a doctor has advised you to disclose.
					</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>Change of address.</Typography>
				</Box>

				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>Change in use of the car.</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>New drivers of the car.</Typography>
				</Box>
				<Box component='li' sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
					<Done sx={{ color: 'secondary.main' }} />
					<Typography variant='subtitle2'>Change of ownership of the car.</Typography>
				</Box>
				<Box
					//sx={{ padding: "6px, 16px, 6px, 16px", }}
					sx={{
						top: 0,
						right: 0,
						backgroundColor: theme.palette.grey[200],
						color: theme.palette.secondary.main,
						p: 2,
						m: { xs: 0, md: 4 },
						mb: { xs: 2, md: 4 },
						width: 'fit-content',
						borderRadius: 2,
					}}
				>
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<Box>
							<Typography variant='subtitle2'>
								{' '}
								This list is not exhaustive and failure to inform the insurer of relevant information can invalidate the
								policy and may mean that the insurer will not pay out in the event of accident. The insurer may overlook
								failure to report changes of circumstances in some cases, but this is unlikely if you failed to do so
								when the policy came up for renewal. If you are in any doubt about whether any facts are material or
								not, they should be disclosed rather than ignored. Failure to divulge any material fact could invalidate
								your policy. Safety first – if you’re in any doubt as to whether something constitutes a material fact
								please do not continue and instead contact one of our representatives. Please contact 02077410015 if
								there are any changes to the information since your last policy.
							</Typography>

							<Typography variant='subtitle2' sx={{ marginTop: '10px' }}>
								{' '}
								Confirm below that there have been no material changes since your last policy.{' '}
							</Typography>
						</Box>
						<ErrorIcon
							sx={{
								color: theme.palette.secondary.main,
								fontSize: 40,
								marginLeft: 'auto',
								marginRight: -1,
							}}
						/>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Disclaimer;
